"use client";
import React, { useState, useEffect } from "react";
import useFetch from "@/app/useFetch";
import Link from "next/link";
import { IMG_URL } from "@/app/config";
import { useTheme } from "@/app/theme-provider";
import Loader from "./Loader";
import Pegination from "./Pegination";
import { formatDate } from "@/app/helpers";


const FirOnline = () => {
    const { language } = useTheme();

    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);

    const [searchTerm, setSearchTerm] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(searchTerm);
            setCurrentPage(1); // reset to page 1 when searching
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm]);

    const { data: list = [], totalPages, loading, error } = useFetch(
        "/website/general-information-fir-online",
        {
            page: currentPage,
            limit: limit,
            search: debouncedSearch,
        },
        [debouncedSearch, currentPage, limit]
    );

    const handlePageChange = (pageNumber) => {
        if (pageNumber > 0 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    return (
        <>
            <section className="mt-4">
                <div className="row mb-3 justify-content-end">
                    <div className="search-box d-flex align-items-center">
                        <input
                            type="text"
                            placeholder={language === "en" ? "Search" : "തിരയുക..."}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                </div>

                {loading ? (
                    <Loader n={24} f={0.3} />
                ) : (
                    <>
                        <div className="table-responsive tenders-table">
                            <table className="table table-bordered text-center align-middle">
                                <thead className="thead-dark">
                                    <tr>
                                        <th>{language === "en" ? "Sl No." : "ക്രമം നമ്പർ"}</th>
                                         <th>{language === "en" ? "Date" : "തീയതി"}</th>
                                        <th>{language === "en" ? "FIR No" : "എഫ്ഐആർ നമ്പർ"}</th>
                                        <th>{language === "en" ? "Unit" : "യൂണിറ്റ്"}</th>
                                        <th>{language === "en" ? "Preview" : "പ്രിവ്യൂ"}</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {list.length > 0 ? (
                                        list.map((item, index) => (
                                            <tr key={index}>
                                                <td>{(currentPage - 1) * limit + index + 1}</td>
                                                 <td>{formatDate(item.date )}</td>
                                                <td>{item.firno}</td>

                                                <td>{item.unit}</td>

                                                <td>
                                                    <Link
                                                        target="_blank"
                                                        href={`${IMG_URL}${item.downloadfile}`}
                                                    >
                                                        <button>
                                                            {language === "en"
                                                                ? "Download"
                                                                : "ഡൗൺലോഡ്"}
                                                        </button>
                                                    </Link>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="5">No data found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        {totalPages > 1 && (
                            <Pegination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={handlePageChange}
                            />
                        )}
                    </>
                )}
            </section>
        </>
    );
};

export default FirOnline;
